export const OperacionCLFBFields = {
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodOperacion: 'codOperacion',
    DescOperacion: 'descOperacion',
    FechaAprobacion: 'fechaAprobacion',
    FechaVencimiento: 'fechaVencimiento',
    FechaAlta: 'fechaAlta',
    AgregadoNeto: 'agregadoNeto',
    AgregadoAbsoluto: 'agregadoAbsoluto',
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    IdMensaje: 'idMensaje',
    EstadoFinalizado: 'estadoFinalizado',
    PermiteEditar: 'permiteEditarOperacion',
    PermiteEliminar: 'permiteEliminarOperacion',
    ListaDetalles: 'detalles',
    BitEnvio: 'enviar'
} as const

export enum OperacionCLFBDetalleFields {
    IdProvisional = 'idProvisional',
    IdOperacion = 'idOperacion',
    CodOperacionActivoTipo = "codOperacionActivoTipo",
    DescOperacionActivoTipo = "descOperacionActivoTipo",
    CreditLimitNeto = 'creditLimitNeto',
    CreditLimitAbsoluto = 'creditLimitAbsoluto',
    CreditLimitConcentracionMaxima = 'creditLimitConcentracionMaxima',
    StopLossVerde = 'stopLossVerde',
    StopLossAmarilla = 'stopLossAmarilla',
    StopLossRoja = 'stopLossRoja',
    HoldingPeriodVerde = 'holdingPeriodVerde',
    HoldingPeriodAmarilla = 'holdingPeriodAmarilla',
    HoldingPeriodRoja = 'holdingPeriodRoja',
    PermiteModificar = 'permiteModificar'
}

export enum OperacionCLFBDetalleHistoriaFields {
    UserId = 'idUsuarioAnterior',
    User = 'usuarioAnterior',
    LastUpdateUserId = 'idUsuarioModificacion',
    LastUpdateUser = 'usuarioModificacion',
    LastUpdateStage = 'nombreEtapaModificacion',
    LastUpdateDate = 'fecha',

}

export enum OperacionCLFBLimitesAprobadosFields {
    LastUpdateUser = 'usuarioUltMod',
    LastUpdateDate = 'fechaUltMod',
    LimitList = 'limites',
    ApprovalDate = 'fechaAprobacion',
    ExpirationDate = 'fechaVencimiento',
    MessageId = 'idMensaje',
    CountryCode = 'codPais',
    CountryName = 'nombrePais',
}

